<template>
  <div class="products-crud">
    <h1>Gestión de Productos</h1>
    <form @submit.prevent="saveProduct">
      <input type="hidden" v-model="product.id">
      <input type="text" v-model="product.nombre" placeholder="Nombre del Producto" required>
      <label>
        <input type="checkbox" v-model="product.activo"> Activo
      </label>
      <button type="submit">Guardar</button>
      <button type="button" @click="clearForm" v-if="product.id">Cancelar Edición</button>
    </form>

    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Nombre</th>
          <th>Activo</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="prod in products" :key="prod.id">
          <td>{{ prod.id }}</td>
          <td>{{ prod.nombre }}</td>
          <td>{{ prod.activo ? 'Sí' : 'No' }}</td>
          <td>
            <button @click="editProduct(prod)">Editar</button>
            <button @click="deleteProduct(prod.id)">Eliminar</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProductsCRUD',
  data() {
    return {
      product: {
        id: null,
        nombre: '',
        activo: true,
      },
      products: [],
    };
  },
  created() {
    this.fetchProducts();
  },
  methods: {
    async fetchProducts() {
      try {
        const response = await axios.get('/api/products');
        this.products = response.data;
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    },
    async saveProduct() {
      try {
        if (this.product.id) {
          await axios.put(`/api/products/${this.product.id}`, this.product);
        } else {
          await axios.post('/api/products', this.product);
        }
        this.clearForm();
        this.fetchProducts();
      } catch (error) {
        console.error('Error saving product:', error);
      }
    },
    editProduct(product) {
      this.product = { ...product };
    },
    async deleteProduct(id) {
      if (confirm('¿Estás seguro de que quieres eliminar este producto?')) {
        try {
          await axios.delete(`/api/products/${id}`);
          this.fetchProducts();
        } catch (error) {
          console.error('Error deleting product:', error);
        }
      }
    },
    clearForm() {
      this.product = {
        id: null,
        nombre: '',
        activo: true,
      };
    },
  },
};
</script>

<style scoped>
.products-crud {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

input[type="text"], button {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

button {
  background-color: #42b983;
  color: white;
  cursor: pointer;
}

button:hover {
  background-color: #369f75;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
}
</style>
